'use client';

import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { SESSION_ERROR_MESSAGE } from '@upms/auth';
import { processError } from '@/lib/processError';
import { getSignInWithRedirect } from './AuthContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 300,
      throwOnError: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      processError(error, {
        feature: String(query.queryKey[0] ?? 'query'),
        operation: String(query.queryKey[1] ?? ''),
      });

      // TODO: Deliver a better way to handle stale / expired sessions
      if (error.message === SESSION_ERROR_MESSAGE) {
        const path = getSignInWithRedirect();
        window.location.assign(path);
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      processError(error, {
        feature: String(mutation.options.mutationKey?.[0] ?? 'mutation'),
        operation: String(mutation.options.mutationKey?.[1] ?? ''),
      });
    },
  }),
});

interface QueryProviderProps {
  children: ReactNode;
}

export const QueryProvider = ({ children }: QueryProviderProps) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
